/** Cabeçalho opcional recomendado em mutações financeiras (idempotência alinhada ao contrato do backend). */
export function idempotencyKeyHeaders(): { 'Idempotency-Key': string } {
  const key =
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
  return { 'Idempotency-Key': key };
}
